import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const createPYESnapshotStep = defineStepConfig({
  type: "create_pye_snapshot",
  name: "Create PYE Snapshot",
  description:
    "Creates or updates a monthly Post Year-End report snapshot for the prior fiscal year",
  category: "Utility",
  libraryModule: "Rebates",

  inputSchema: z.object({
    estimatesStored: z.number().optional(),
  }),

  outputSchema: z.object({
    success: z.boolean(),
    fiscalYear: z.number(),
    snapshotDate: z.string(),
    message: z.string(),
  }),

  configSchema: z.object({}),

  emits: [] as const,
});
